module.exports = __webpack_public_path__ + "img/9788974000783.6de924f2.jpg";